var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import camelToUnderscore from '@returnmates/client-core/src/utils/camelToUnderscore';
import parseTpl from '@returnmates/client-core/src/utils/parseStringTemplate';
var parseTemplate = function (template, packs) {
    var parsedTemplate = template.replace(/\${(.*?)}/g, function (_, key) {
        var _a = key.split('.'), pathWithIndex = _a[0], properties = _a.slice(1);
        var index = parseInt(pathWithIndex.match(/\d+/)[0]);
        if (packs[index]) {
            var value = packs[index];
            var property = void 0;
            for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
                property = properties_1[_i];
                value = value[property];
                if (typeof value === 'undefined' || value === null) {
                    return '';
                }
            }
            if (typeof value === 'string' && property === 'id') {
                value = value.replace(/-/g, '');
            }
            return value;
        }
        return '';
    });
    return parsedTemplate;
};
var sortPacksByAttribute = function (array, attribute) {
    return array.sort(function (a, b) {
        var attrA = a.partnerAttributes ? JSON.parse(a.partnerAttributes) : {};
        var attrB = b.partnerAttributes ? JSON.parse(b.partnerAttributes) : {};
        var valA = attrA[attribute] || '';
        var valB = attrB[attribute] || '';
        if (valA < valB) {
            return -1;
        }
        if (valA > valB) {
            return 1;
        }
        return 0;
    });
};
export var groupPackagesByAttribute = function (array, attribute, max) {
    var groups = [];
    var currentGroup = [];
    var sortedPackages = sortPacksByAttribute(array, attribute);
    sortedPackages.forEach(function (item) {
        if (!item.partnerAttributes || !item.partnerAttributes.includes(attribute)) {
            groups.push([item]);
        }
        else {
            var value = JSON.parse(item.partnerAttributes)[attribute];
            if (currentGroup.length >= max ||
                (currentGroup.length > 0 && currentGroup[0].value !== value)) {
                groups.push(currentGroup.map(function (groupItem) { return groupItem.item; }));
                currentGroup = [];
            }
            currentGroup.push({
                value: value,
                item: item,
            });
        }
    });
    if (currentGroup.length > 0) {
        groups.push(currentGroup.map(function (groupItem) { return groupItem.item; }));
    }
    return groups;
};
export var hydrateSingleLabelTemplate = function (template, pack) {
    var pkgIdRe = /{Package.id}/g;
    var re = /{Package./g;
    var currentTemplate = template === null || template === void 0 ? void 0 : template.replace(pkgIdRe, pack.id.split('-').join('')).replace(re, '${pack.');
    var modifiedPartnerAttr = {};
    var partnerAttrObj = pack.partnerAttributes ? JSON.parse(pack.partnerAttributes) : {};
    for (var key in partnerAttrObj) {
        //@ts-ignore
        modifiedPartnerAttr[camelToUnderscore(key)] = partnerAttrObj[key];
    }
    var parsedTemplate = parseTpl(currentTemplate || '', {
        pack: __assign(__assign({}, pack), { partnerAttributes: pack.partnerAttributes ? modifiedPartnerAttr : null }),
    });
    return parsedTemplate;
};
export var hydrateMultipleLabelTemplate = function (template, packs, count) {
    var zpl = template;
    for (var i = 0; i < count; i++) {
        var packageRegex = new RegExp("{Package\\[".concat(i, "\\]."), 'g');
        zpl = zpl.replace(packageRegex, "${packs[".concat(i, "]."));
    }
    var modifiedPacks = packs.map(function (pack) {
        if (pack.partnerAttributes) {
            var modifiedPartnerAttr = {};
            var partnerAttrObj = pack.partnerAttributes ? JSON.parse(pack.partnerAttributes) : {};
            for (var key in partnerAttrObj) {
                //@ts-ignore
                modifiedPartnerAttr[camelToUnderscore(key)] = partnerAttrObj[key];
            }
            return __assign(__assign({}, pack), { partnerAttributes: modifiedPartnerAttr });
        }
        return pack;
    });
    var parsedTemplate = parseTemplate(zpl || '', modifiedPacks);
    return parsedTemplate;
};
//# sourceMappingURL=hydrateLabelTemplate.js.map